<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12" class="px-0">
        <h5 class="mb-0">{{ $t("Контрагент хисоботи")}}</h5>
      </b-col>
      <div class="my-1 column3">
        <label for="">Вақт 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </div>
      <div class="my-1 column3">
        <label for="">Вақт 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </div>
      <div class="my-1 column3">
        <label>Склад</label>
        <v-select
          class="form-control-sm md-input"
          :options="skladlist"
          :disabled="skladhave"
          v-model="datas.sklad_id"
          :reduce="(name) => name.id"
          :clearable="false"
          label="name"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              v-bind="attributes"
              v-on="events"
              aria-activedescendant="null"
            />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em
                ><b>{{ search }}</b></em
              >
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="my-1 column3">
        <label for="">{{$t('Ходим')}}</label>
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
              :options="userlist" v-model="datas.user_id" :reduce="name => name.id" label="name"
           >
              <!-- <template #search="{ attributes, events }"> -->
                <!-- <input class="vs__search" v-bind="attributes" v-on="events" ref="focused" /> -->
              <!-- </template> -->
            </v-select>
      </div>
      <!-- <div class="my-1 column2-5">
        <label for="">{{$t('Тип оплата')}}</label>
        <v-select
          :clearable="false"
          class="form-control-sm"
          :options="pricelist"
          v-model="datas.price_type"
          :reduce="name => name.id"
          label="name"
        >
        </v-select>
      </div> -->
      <div class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          Кўриш
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
      </div>
      <div class="limiter" id="tableId">
        <md-card>
          <md-card-content>
        <table class="table table-bordered" style="font-size: 13px;">
          <thead class="thead-light">
            <tr>
              <th class="column0 dollar">#</th>
              <th class="dollar column5">{{ $t("Номи") }}</th>
              <th class="dollar">{{ $t("Бош. қолдиқ") }}</th>
              <th class="dollar">{{ $t("Кирим") }}</th>
              <th class="dollar">{{ $t("Расход") }}</th>
              <th class="dollar">{{ $t("Якуний қолдиқ") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row100 body"
              v-for="(item, index) in results"
              :key="index"
              @click="RouteSverka(item.id)"
              style="cursor: pointer"
            >
              <td class="column0">
                {{ index + 1 }}
              </td>
              <td class="column5">
                {{ item.name }}
              </td>
              <td class="kol">
                    {{ item.begin_total | numFormats }}
              </td>
              <td class="kol">
                    {{ item.total_kirim | numFormats }}
              </td>
              <td class="kol">
                    {{ item.total_chiqim | numFormats }}
              </td>
              <td class="kol">
                    {{ item.end_total | numFormats }}
              </td>
            </tr>
          </tbody>
          <thead class="summatable1">
            <tr>
              <td colspan="2" style="width: 25%;">{{ $t("Жами") }}</td>
              <td class="kol">
                {{ bosh_summ | numFormats }}
              </td>
              <td class="kol">
                <span :class="{ red: kirim_summ < 0 }" v-if="kirim_summ != 0">{{
                  kirim_summ | numFormats
                }}</span>
              </td>
              <td class="kol">
                <span
                  :class="{ red: chiqim_summ < 0 }"
                  v-if="chiqim_summ != 0"
                  >{{ chiqim_summ | numFormats }}</span
                >
              </td>
              <td class="kol">
                <span v-if="end_summ > 0">
                    {{ end_summ | numFormats }}
                </span>
              </td>
            </tr>
          </thead>
        </table>
        </md-card-content>
        </md-card>
      </div>
    </b-row>
    <sklad :datas="datas"></sklad>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import { print } from "../../../components/mixins/print.js";
import { Sklad } from "@/pages";
export default {
  components: { Sklad },
  mixins: [print],
  data() {
    return {
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        user_id: null,
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
      },
      summ: 0,
      summ_qarz: 0,
      summ_dollar: 0,
      summ_dollar_qarz: 0,
      bosh_summ: 0,
      end_summ: 0,
      kirim_summ: 0,
      chiqim_summ: 0,
      sklad: "",
      userlist: [],
      skladlist: [],
      errors: "",
      results: [],
    };
  },
  created() {
    let self = this;
    self.Userlist();
    // });
    self.$root.$on("skladone", function (getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function (getdata) {
      self.skladlist = getdata;
    });
  },
  methods: {
    Userlist() {
        let self = this;
        axios
          .get("api/v1/staff/")
          .then(function (response) {
            self.userlist = response.data;
          });
      },
    downloadExl() {
      this.$store.state.xls=true;
      setTimeout(() => {
        
        let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
        var wscols = [{ width: 5 },{ width: 25 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 15 },{ width: 11 },{ width: 7 },{ width: 7 },{ width: 11 },{ width: 11 }]; 
        wb.Sheets.Sheet1['!cols']=wscols;
        let wbout = XLSX.write(wb, wopts);       
        console.log(wb.Sheets.Sheet1['!cols']);
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8",
        }),
        new Date() + "kontragent_xisobot.xlsx"
      );
      setTimeout(() => {
        this.$store.state.xls=false;
      }, 2000);
      }, 2000);
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    Clicked(id) {
      localStorage.setItem("date1", this.datas.date1);
      localStorage.setItem("date2", this.datas.date2);
      localStorage.setItem("user", id);
      localStorage.setItem("sklad_id", this.datas.sklad_id);
      this.$router.push({ path: "/xisobot/sverka/user" });
    },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1).valueOf().toString().slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2).valueOf().toString().slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id,
        user_id: self.datas.user_id,
      };
      axios({
        method: "post",
        url: "api/v1/report/user",
        data: datas,
      }).then(function (response) {
        self.results = response.data;
        self.bosh_summ = 0;
        self.kirim_summ = 0;
        self.chiqim_summ = 0;
        self.end_summ = 0;
        self.results.forEach(function (key, value) {
            self.end_summ += key.end_total;
            self.bosh_summ += key.begin_total;
            self.kirim_summ += key.total_kirim;
            self.chiqim_summ += key.total_chiqim;
        });
      });
    },
    RouteSverka(id) {
      let SverkaWindow;
      SverkaWindow = window.open(
        "#/xisobot/sverka/user/" +
          id +
          "/" +
          this.datas.sklad_id +
          "/" +
          this.datas.date1 +
          "/" +
          this.datas.date2,
        "_blank",
        "width=1000, height=1000"
      );
    },
  },
};
</script>
<style scoped>
.my-1 {
  padding-right: 10px !important;
}
.table100-body {
  max-height: 460px;
}
</style>
